<template>
  <div>
    <div class="tips-container">
      <span style="font-weight: bold">{{ $t('userManage.Note') }}：</span>
      <span>{{ $t('userManage.AfterResettingOriginalPasswordWillBecomeInvalidImmediately') }}</span>
    </div>
    <div class="detail-container">
      <div style="border-right: 1px solid #ddd;padding: 20px;flex: 1">
        <div>{{ $t('collectionCenter.compellation') }}</div>
        <div style="font-weight: bold">{{ accountDetail.realName }}</div>
      </div>
      <div style="padding: 20px;flex: 1;">
        <div>{{ $t('userManage.LoginAccount') }}</div>
        <div style="font-weight: bold">{{ accountDetail.username }}</div>
      </div>
    </div>
    <div>
      <el-form ref="confirmRestRef" :model="restPassword" size="small">
        <el-form-item
          prop="checked"
          :rules="{
            required: true,
            message: $t('userManage.PleaseCheckTheConfirmation'),
            trigger: 'change'
          }"
        >
          <el-checkbox-group v-model="restPassword.checked">
            <!--我已确认本次将仅创建校验通过的 121 个账号，校验失败的 5 条数据不会创建。-->
            <el-checkbox label="1">
              {{ $t('userManage.IConfirmResetThePassword') }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :title="$t('userManage.ResetTemporaryWorkerAccountPassword')"
      :visible.sync="showRestPasswordTips"
      width="800px"
      :append-to-body="true"
    >
      <div>
        <div class="success-container">
          <div class="success-icon">
            <i class="el-icon-check" style="color:#0db35b;font-size: 50px" />
          </div>
        </div>
        <div style="text-align: center;font-weight: bold;font-size: 18px">{{ $t('userManage.PasswordResetSuccessful') }}</div>
        <div style="text-align: center;margin-bottom: 20px;">{{ $t('userManage.TheNewTemporaryPassword') }}</div>
        <div class="new-password-con">
          <div>{{ $t('userManage.NewTemporaryPassword') }}</div>
          <div style="font-size: 20px;font-weight: bold;margin: 10px 0;">{{ newPassword }}</div>
          <div>
            <el-button plain @click="copyPassword(newPassword)">{{ $t('userManage.CopyPassword') }}</el-button>
          </div>
        </div>
        <div class="password-tips">
          {{ $t('userManage.TheNewTemporaryPasswordCan') }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmComplete">{{ $t('Resource.complete') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getFreelancerPasswordApi } from '@/api/user';
import { copyData } from '@/utils/copyData';
export default {
  name: 'RestPassword',
  props: {
    accountDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      restPassword: {
        checked: []
      },
      newPassword: null,
      showRestPasswordTips: false
    };
  },
  methods: {
    // 确认重置密码
    confirmResetPassword() {
      this.$refs.confirmRestRef.validate(valid => {
        if (valid) {
          getFreelancerPasswordApi({ id: this.accountDetail.id }).then(res => {
            if (res.code === 200) {
              this.newPassword = res.data.newPassword;
              this.showRestPasswordTips = true;
            }
          });
        }
      });
    },
    // 确认完场
    confirmComplete() {
      this.showRestPasswordTips = false;
      this.$emit('closeWindow', true);
    },
    // 复制密码
    copyPassword(data) {
      copyData(data);
    }
  }
};
</script>
<style scoped>
.tips-container {
  border: 1px solid #f3debb;
  border-radius: 10px;
  background:#fff8ee;
  padding: 20px;
  color:#7b5d2c;
  margin-bottom: 10px;
}
.detail-container {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 20px;
}
.success-container {
  display:flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.success-icon {
  background:#eaf8f0;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display:flex;
  align-items: center;
  justify-content: center;
}
.new-password-con {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  background:#f8fafc;
  margin-bottom: 20px;
}
.password-tips {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 15px;
  background:#f4f8fc;
}
</style>
